(() => {
  const start = () => {
    const root = document.querySelector('.product-details');
    if (!root || root.dataset.mrShoppingReady) return;
    root.dataset.mrShoppingReady = 'true';
    const initialize = () => {
      const copy = root.querySelector('[data-mr-options]');
      if (!copy) return;
      root.querySelectorAll('.globo-swatch-list .value').forEach((list, index) => {
        if (list.dataset.mrEnhanced) return;
        const items = Array.from(list.children).filter(item => item.querySelector('input[type="radio"]'));
        if (items.length <= 8) return;
        list.dataset.mrEnhanced = 'true';
        list.id ||= `mr-swatch-list-${index}`;
        let expanded = false;
        const tools = document.createElement('div');
        tools.className = 'mr-swatch-tools';
        const label = document.createElement('label');
        label.textContent = copy.dataset.findLabel;
        const input = document.createElement('input');
        input.type = 'search';
        input.autocomplete = 'off';
        input.placeholder = copy.dataset.findPlaceholder;
        input.setAttribute('aria-controls', list.id);
        label.append(input);
        const status = document.createElement('p');
        status.className = 'mr-swatch-status';
        status.setAttribute('role', 'status');
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'mr-swatch-toggle';
        toggle.setAttribute('aria-controls', list.id);
        tools.append(label, status);
        list.before(tools);
        list.after(toggle);
        const nameOf = item => item.querySelector('input').value;
        const render = () => {
          const query = input.value.trim().toLocaleLowerCase();
          let matches = 0;
          items.forEach((item, i) => {
            const matchesQuery = nameOf(item).toLocaleLowerCase().includes(query);
            if (matchesQuery) matches++;
            item.hidden = query ? !matchesQuery : !(expanded || i < 8 || item.querySelector('input').checked);
          });
          const chosen = items.find(item => item.querySelector('input').checked);
          const result = query ? `${matches} ${copy.dataset.matchLabel}` : '';
          const selected = chosen ? `${copy.dataset.selectedLabel} ${nameOf(chosen)}` : copy.dataset.chooseLabel;
          status.textContent = [selected, result].filter(Boolean).join(' · ');
          toggle.hidden = Boolean(query);
          toggle.textContent = expanded ? copy.dataset.showLess : `${copy.dataset.showAll} (${items.length})`;
          toggle.setAttribute('aria-expanded', String(expanded));
        };
        input.addEventListener('input', render);
        toggle.addEventListener('click', () => { expanded = !expanded; render(); });
        list.addEventListener('change', render);
        list.addEventListener('invalid', () => { input.value = ''; expanded = true; render(); }, true);
        render();
      });
    };
    initialize();
    new MutationObserver(initialize).observe(root, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
